var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOpenQuestion = function SvgOpenQuestion(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 134,
    viewBox: "0 0 154 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2737_94190)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2737_94190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27,
    width: 124,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 34,
    x2: 132,
    y2: 34,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 49,
    width: 124,
    height: 69,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 58,
    x2: 113,
    y2: 58,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 70,
    x2: 113,
    y2: 70,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.583 57.0324C128.664 55.9739 129.246 55.4028 131.144 57.3002C133.036 59.1925 132.469 59.7736 131.419 60.851C131.33 60.9421 131.238 61.0367 131.144 61.1359L127.308 57.3002C127.404 57.2084 127.495 57.1188 127.583 57.0324ZM126.459 58.1494L126.457 58.1514L126.449 58.1589C123.848 60.7654 119.782 64.8266 119.782 64.8266C119.735 64.8733 119.701 64.9317 119.685 64.9956L118.96 67.7508L118.96 67.752L118.96 67.7519L118.512 69.4767C118.479 69.6048 118.516 69.741 118.609 69.8345C118.703 69.9281 118.839 69.9652 118.967 69.9319L120.691 69.4842L120.693 69.4836L123.448 68.7593C123.512 68.7425 123.571 68.709 123.617 68.6623L130.283 61.9966L130.285 61.9945L130.293 61.9871L126.459 58.1494Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 83,
    x2: 128,
    y2: 83,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 96,
    x2: 128,
    y2: 96,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 109,
    x2: 128,
    y2: 109,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 2.61116 14.6112 -5 24 -5H130C139.389 -5 147 2.61116 147 12V19C147 19 144.761 19 142 19H12C9.23858 19 7 19 7 19V12ZM147 127H7H147ZM7 127V7V127ZM147 7V127V7Z",
    fill: "#343A40",
    mask: "url(#path-1-inside-1_2737_94190)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2737_94190",
    x: 0,
    y: 0,
    width: 154,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.364706 0 0 0 0 0.494118 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2737_94190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2737_94190",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpenQuestion);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";